import logo from './logo.svg';
import './App.css';
import TimelineCarousel  from './TimelineCarousel.jsx';
import CustomizedTimeline from './TimeLine.js';
import Timeline2 from'./TimeLine2.js';
import Timeline from './timeline.jsx';

import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#B41E8E',
    },
    secondary: {
      main: '#A18A50',
    },
  },
});


function App() {
  return (
   /* <div className="App">
        <ThemeProvider theme={theme}>
          <CustomizedTimeline />
        </ThemeProvider>  
    </div>*/
    <div className="App">
      <Timeline></Timeline>
    </div>
  );
}

export default App;
